import { createContext, useContext } from "react";

export const StudyPathSideBarContext = createContext({ course: null });

export const useStudyPathSideBar = () => {
  const context = useContext(StudyPathSideBarContext);
  if (!context) {
    throw new Error("useStudyPathSideBar must be used within a StudyPathSideBarProvider");
  }
  return context;
};
